var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.385 11.5L4.5 14.184l20 22.316 20-22.316-2.885-2.684-17.116 19.097z","fillRule":"evenodd"}));
}

CaretDown.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
